export default __webpack_public_path__ + "static/media/steth_logo.1c279349.webp";